// extracted by mini-css-extract-plugin
export default {"zoomModal":"l4-z","image":"m4-z","button":"n4-z","isOverlayShown":"o4-z"};